import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';

export function useGetWorkflowAutomation({ automationId }: { automationId?: string }) {
  const { data, loading, error } = useQuery<
    MBAPI.GetAutomationQuery,
    MBAPI.GetAutomationQueryVariables
  >(Queries.automation.getAutomation, {
    variables: {
      id: automationId ?? '',
    },
    skip: isNil(automationId),
  });

  return {
    automation: data?.getAutomation,
    loading,
    error,
  };
}
